import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 4px;
`;

export const Tag = styled.div`
  padding: 4px 8px;
  background: #f9f9f9;
  border: 1px solid #e2e2e5;
  border-radius: 3px;
  width: min-content;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
